/** Preferência WhatsApp Cloud / Spark: ogg → mp4 → webm (webm é reencoded no envio Spark). */
export function pickRecorderMime(): { mime: string; ext: string } {
  const MR = typeof MediaRecorder !== 'undefined' ? MediaRecorder : null;
  const candidates: { mime: string; ext: string }[] = [
    { mime: 'audio/ogg;codecs=opus', ext: 'ogg' },
    { mime: 'audio/ogg', ext: 'ogg' },
    { mime: 'audio/mp4', ext: 'm4a' },
    { mime: 'audio/webm;codecs=opus', ext: 'webm' },
    { mime: 'audio/webm', ext: 'webm' },
  ];
  if (MR?.isTypeSupported) {
    for (const c of candidates) {
      if (MR.isTypeSupported(c.mime)) return c;
    }
  }
  return { mime: 'audio/webm', ext: 'webm' };
}
